// Arabic locale with explicit Gregorian calendar override.
// `ar-SA` alone defaults to the Islamic/Hijri calendar in most browsers —
// which is NOT what the business wants. Always force the Gregorian calendar.
const LOCALE = 'ar-SA-u-ca-gregory';

function toDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDate(value, opts) {
  const d = toDate(value);
  if (!d) return '-';
  return d.toLocaleDateString(LOCALE, opts || { year: 'numeric', month: 'long', day: 'numeric' });
}

export function formatDateShort(value) {
  return formatDate(value, { year: 'numeric', month: '2-digit', day: '2-digit' });
}

export function formatDateTime(value, opts) {
  const d = toDate(value);
  if (!d) return '-';
  return d.toLocaleString(LOCALE, opts || {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export function formatTime(value) {
  const d = toDate(value);
  if (!d) return '-';
  return d.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit' });
}
